import { render, staticRenderFns } from "./unvote.vue?vue&type=template&id=79479725&scoped=true&"
import script from "./unvote.vue?vue&type=script&lang=js&"
export * from "./unvote.vue?vue&type=script&lang=js&"
import style0 from "./unvote.vue?vue&type=style&index=0&id=79479725&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79479725",
  null
  
)

export default component.exports